import { createColumnHelper } from "@tanstack/react-table";
import { indexer } from "../../../../utils";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  fetchProductInquiryDownload,
  useProductInquiryList,
} from "../../../../api/inquiries/product-inquiry/use-product-inquiry";
import Table from "../../../../components/ui/Table/Table";
import { convertDateToDateTime } from "../../../../helper/formatDate/formate-date";

const options = [
  { id: 1, name: "최신순" },
  { id: 2, name: "최신순" },
  { id: 3, name: "최신순" },
];

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexing = indexer(page, pageSize, total);

        return <div>{indexing(index)}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.status, {
      header: "처리상태",
      cell: (info) => {
        const val = info.getValue();
        return (
          <div>
            {val ? (
              val === "PENDING" ? (
                <span className="text-[#e80000]">답변대기</span>
              ) : (
                "답변완료"
              )
            ) : (
              "-"
            )}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.hospitalMember?.email, {
      header: "아이디(이메일주소)",
      cell: (info) => {
        const val = info.getValue();

        const email =
          val?.length > 10 ? (
            <div>
              {val?.substring(0, 25)}
              <br />
              {val?.slice(25)}
            </div>
          ) : (
            val
          );
        return <div className="line-clamp-2">{val ? email : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.hospital?.name, {
      header: "병원명",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "관련 상품명",
      cell: InquiryTitle,
    }),

    columnHelper.accessor((row) => row?.question, {
      header: "문의 내용",
      cell: (info) => {
        const val = info.getValue();
        const question = val?.length > 15 ? val?.substring(0, 15) + "..." : val;
        return <div>{question ? question : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.createdAt, {
      header: "문의일시",
      cell: (info) => {
        const val = info.getValue();
        const date = convertDateToDateTime(val);
        return <div>{val ? date : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.answeredAt, {
      header: "답변일시",
      cell: (info) => {
        const val = info.getValue();
        const date = convertDateToDateTime(val);
        return <div>{val ? date : "-"}</div>;
      },
    }),

    columnHelper.display({
      header: "자세히보기",
      id: "actions",
      cell: ButtonActions,
    }),
  ];
};

function InquiryTitle(props) {
  const val = props.row.original?.productGroup?.name;
  const prodId = props.row.original?.productGroup?.id;
  const navigate = useNavigate();

  const handleToDetail = (prodId) => {
    navigate(`/product-management/product-group/${prodId}`);
  };

  const title = val?.length > 15 ? val?.substring(0, 15) + "..." : val;
  return (
    <div className="cursor-pointer" onClick={() => handleToDetail(prodId)}>
      {title ? title : "-"}
    </div>
  );
}

function ButtonActions(props) {
  const id = props.row.original?.id;
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`product-inquiry/${id}`)}
      className="w-10 p-[1px] border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      상세
    </button>
  );
}

export function ProductInquiryTable(props) {
  const { filter } = props;
  const { isEmpty, getDataTableProps } = useProductInquiryList(filter);
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().total;
  const onSave = async () => {
    await fetchProductInquiryDownload().then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `product-inquiry-${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  return (
    <>
      {isEmpty ? (
        <div className="flex justify-center mt-[60px] text-[#999999] text-center">
          등록된 상품이 없습니다.
          <br /> ONEDAY Mall에 상품을 등록하실 경우, '+ 상품등록'을
          진행해주세요.
        </div>
      ) : (
        <Table
          onSave={onSave}
          hasPageSizeFilter={false}
          columns={columns(currentPage, pageSize, totalData)}
          sorts={options}
          {...getDataTableProps()}
        />
      )}
    </>
  );
}
